import EdiRequestApp from '../edi_request/App'
import EdiRequestAuthentication from '../edi_request/Index'
import RegistrationIndex from '../edi_request/registrations/Index'
import UnsubscribedNew from '../edi_request/unsubscribed/New'
import UnsubscribedShow from '../edi_request/unsubscribed/Show'
import UnsubscribedEdit from '../edi_request/unsubscribed/Edit'
import SubscribedNew from '../edi_request/subscribed/New'
import SubscribedShow from '../edi_request/subscribed/Show'
import SubscribedEdit from '../edi_request/subscribed/Edit'

export default {
  path: '/edi_request',
  component: EdiRequestApp,
  meta: { isPublic: true },
  children: [
    {
      path: '/edi_request/:token',
      name: 'EdiRequestAuthentication',
      component: EdiRequestAuthentication,
      meta: { siteSubTitle: '認証', isPublic: true }
    },
    {
      path: '/edi_request/:token/registrations/',
      name: 'EdiRequestRegistrations',
      component: RegistrationIndex,
      meta: { siteSubTitle: 'JWNET-EDI連携サービス利用申し込み', isPublic: true }
    },
    {
      path: '/edi_request/:token/unsubscribed/new',
      name: 'EdiRequestUnsubscribed',
      component: UnsubscribedNew,
      meta: { siteSubTitle: 'JWNET加入申込（団体加入用）', isPublic: true }
    },
    {
      path: '/edi_request/unsubscribed/:id/show',
      name: 'EdiRequestUnsubscribedShow',
      component: UnsubscribedShow,
      props: route => ({ ediRequestId: route.params.id }),
      meta: { siteSubTitle: 'JWNET加入申込（団体加入用）', isPublic: true }
    },
    {
      path: '/edi_request/unsubscribed/:id/edit',
      name: 'EdiRequestUnsubscribedEdit',
      component: UnsubscribedEdit,
      props: route => ({ ediRequestId: route.params.id }),
      meta: { siteSubTitle: 'JWNET加入申込（団体加入用）', isPublic: true }
    },
    {
      path: '/edi_request/:token/subscribed/new',
      name: 'EdiRequestSubscribed',
      component: SubscribedNew,
      meta: { siteSubTitle: 'JWNET加入情報を利用した申込', isPublic: true }
    },
    {
      path: '/edi_request/subscribed/:id/show',
      name: 'EdiRequestSubscribedShow',
      component: SubscribedShow,
      props: route => ({ ediRequestId: route.params.id }),
      meta: { siteSubTitle: 'JWNET加入情報を利用した申込', isPublic: true }
    },
    {
      path: '/edi_request/subscribed/:id/edit',
      name: 'EdiRequestSubscribedEdit',
      component: SubscribedEdit,
      props: route => ({ ediRequestId: route.params.id }),
      meta: { siteSubTitle: 'JWNET加入情報を利用した申込', isPublic: true }
    }
  ]
}
